import React from 'react';

const SubscriptionStep = ({ 
    subscriptions, 
    selectedSubscription, 
    setSelectedSubscription 
}) => {
    return (
        <div className="space-y-6">
            <div className="text-center mb-6">
                <h3 className="text-xl font-semibold text-white mb-2">Choose Your Subscription Plan</h3>
                <p className="text-gray-400">Select a membership level that suits your needs</p>
            </div>

            {subscriptions.length > 0 ? (
                <div className="space-y-4">
                    {subscriptions.map((subscription) => (
                        <div
                            key={subscription.subscriptionId}
                            className={`card p-6 cursor-pointer border-2 transition-all duration-300 ${
                                selectedSubscription === subscription.subscriptionId
                                    ? 'border-emerald-500 bg-emerald-900/20 ring-2 ring-emerald-500/20'
                                    : 'border-gray-700 hover:border-gray-600 hover:bg-gray-800/30'
                            }`}
                            onClick={() => setSelectedSubscription(subscription.subscriptionId)}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex-1">
                                    <div className="flex items-center">
                                        <input
                                            type="radio"
                                            name="subscription"
                                            value={subscription.subscriptionId}
                                            checked={selectedSubscription === subscription.subscriptionId}
                                            onChange={() => setSelectedSubscription(subscription.subscriptionId)}
                                            className="w-4 h-4 text-emerald-600 bg-gray-700 border-gray-600 focus:ring-emerald-500"
                                        />
                                        <div className="ml-3">
                                            <h4 className="text-lg font-semibold text-white">
                                                {subscription.name}
                                            </h4>
                                            <p className="text-gray-400 text-sm">
                                                {subscription.description || 'Standard membership plan'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className="text-xl font-bold text-white">
                                        £{subscription.price || '0.00'}
                                    </div>
                                    <div className="text-sm text-gray-400">
                                        {subscription.tokenAmount || 0} tokens
                                    </div>
                                    <div className="text-sm text-gray-400">
                                        {subscription.frequency || 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    
                    {/* Pay As You Go Option */}
                    <div
                        className={`card p-6 cursor-pointer border-2 transition-all duration-300 ${
                            selectedSubscription === 'payg'
                                ? 'border-emerald-500 bg-emerald-900/20 ring-2 ring-emerald-500/20'
                                : 'border-gray-700 hover:border-gray-600 hover:bg-gray-800/30'
                        }`}
                        onClick={() => setSelectedSubscription('payg')}
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex-1">
                                <div className="flex items-center">
                                    <input
                                        type="radio"
                                        name="subscription"
                                        value="payg"
                                        checked={selectedSubscription === 'payg'}
                                        onChange={() => setSelectedSubscription('payg')}
                                        className="w-4 h-4 text-emerald-600 bg-gray-700 border-gray-600 focus:ring-emerald-500"
                                    />
                                    <div className="ml-3">
                                        <h4 className="text-lg font-semibold text-white">
                                            Pay As You Go
                                        </h4>
                                        <p className="text-gray-400 text-sm">
                                            No monthly commitment - pay only for what you use
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="text-xl font-bold text-white">
                                    £0.00
                                </div>
                                <div className="text-sm text-gray-400">
                                    Per session pricing
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card p-8 text-center border-2 border-dashed border-emerald-700/40 rounded-xl">
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-14 h-14 rounded-full bg-emerald-900/30 flex items-center justify-center">
                            <svg className="h-7 w-7 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div>
                            <h4 className="text-lg font-semibold text-white mb-1">Subscription arranged with venue</h4>
                            <p className="text-gray-400 text-sm max-w-xs mx-auto">
                                Click <span className="text-emerald-400 font-medium">Next</span> to continue setting up your account.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionStep;
